import React from 'react';
import SortingIcon from '../../icons/SortingIcon/SortingIcon';
import UnsortedIcon from '../../icons/UnsortedIcon/UnsortedIcon';
const ColumnSorterIcon = ({ sortField, currentSortOptions }) => {
    const isSorting = !!currentSortOptions && currentSortOptions.sortField === sortField;
    if (isSorting) {
        return (React.createElement(SortingIcon, { "data-testid": "column_sorter_icon__sort_icon", direction: currentSortOptions.direction }));
    }
    return React.createElement(UnsortedIcon, { "data-testid": "column_sorter_icon__unsorted_icon" });
};
export default ColumnSorterIcon;
